import { ChangeDetectionStrategy, Component, input, TemplateRef } from '@angular/core';
import { CtDocument } from '../../model/ct-batch-model';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { classByKey, DocumentClassKey } from '../../document-classes/document-classes';

@Component({
  selector: 'ct-shared-document-preview-separator',
  template: `
    <fieldset
      class="text-secondary my-3 w-full border-0 border-t border-dashed text-sm"
      [ngClass]="!splitFunctionality() ? 'border-primary' : 'border-secondary'">
      <legend class="m-auto px-4">
        @if (!documentSeparatorLabelTemplate()) {
          @let classes = document().documentClasses;
          @if (classes.length === 0) {
            (Keine Klasse)
          } @else {
            Klasse {{ joinDocumentClassLabels(document().documentClasses) }}
          }
        } @else {
          <ng-container
            [ngTemplateOutlet]="documentSeparatorLabelTemplate()"
            [ngTemplateOutletContext]="{ $implicit: document(), index: documentIndex() }" />
        }
      </legend>
    </fieldset>
  `,
  imports: [NgTemplateOutlet, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentPreviewSeparatorComponent {
  readonly splitFunctionality = input<boolean>(false);
  readonly documentIndex = input.required<number>();
  readonly document = input.required<CtDocument>();

  readonly documentSeparatorLabelTemplate =
    input<TemplateRef<{ $implicit: CtDocument; index: number }>>();

  protected joinDocumentClassLabels(documentClasses: DocumentClassKey[]) {
    return documentClasses.map((documentClass) => classByKey[documentClass].label).join(' + ');
  }
}
